import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { AuctionBidDetails } from './auction-bid.model';

export interface AuctionBidState extends EntityState<AuctionBidDetails> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'auction-bid', idKey: 'Id' })
export class AuctionBidStore extends EntityStore<AuctionBidState> {

  constructor() {
    super();
  }

}

